import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import type { SearchReturnRequestsResponseDto } from "@babackapp/private-api-client";

type LineItem = SearchReturnRequestsResponseDto["returnRequests"][number]["line_items"][number];

type Props = {
  lineItem: LineItem;
  imageLayoutId?: string;
};

export function ReturnRequestLineItem({ lineItem, imageLayoutId }: Props) {
  return (
    <Article variants={{}}>
      {lineItem.image && (
        <ArticleImage src={lineItem.image} layoutId={imageLayoutId} />
      )}
      <ArticleTitle>{lineItem.title}</ArticleTitle>
      <ArticleSubtitle>
        ×{lineItem.quantity} — {lineItem.price}€
      </ArticleSubtitle>
    </Article>
  );
}
